import { useState, useEffect } from 'react';
import AuthService from '../services/AuthService';
import DashboardLicenseApiService from '../services/DashboardLicenseApiService';

const useDashboardLicenseViewModel = () => {
  const [licenses, setLicenses] = useState([]);
  const [selectedLicense, setSelectedLicense] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLicenses = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const data = await DashboardLicenseApiService.getLicenseData();
        setLicenses(data);
        if (data.length > 0) {
          setSelectedLicense(data[0]); // Select first license by default
        }
      } catch (err) {
        setError(err.message || 'Failed to fetch license data');
        AuthService.logoutWhenError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchLicenses();
  }, []);

  const handleLicenseSelect = (licenseId) => {
    const selected = licenses.find(license => license.license_id === licenseId);
    setSelectedLicense(selected);
  };

  return {
    licenses,
    selectedLicense,
    isLoading,
    error,
    handleLicenseSelect
  };
};

export default useDashboardLicenseViewModel;